import User from '@/models/User'

export default function useInitialPage(): Page {
    const el = document.querySelector('script[data-page="app"]')

    const content = el?.textContent || el?.innerHTML

    if (!content) {
        return {
            component: '',
            props: {
                url: {
                    current: '',
                },
            },
            url: '',
            version: 0,
        }
    }

    //@ts-ignore
    return JSON.parse(content)
}


interface SharedPageProps {
    flash?: {
        message: string
        type: "success" | "error" | "info" | "warning"
    }
    auth?: {
        user: User | null
    }
    url: {
        current: string
        intended?: string
    }
    csrf_token?: string
    breadcrumbs?: any
}

interface Page {
    component: string
    props: SharedPageProps
    url: string
    version: number
}
